"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.batchDelete = batchDelete;
exports.batchGet = batchGet;
exports.batchUpdate = batchUpdate;
exports.endpoints = void 0;
exports.feedbackSmartReply = feedbackSmartReply;
exports.fetchOriginal = fetchOriginal;
exports.fetchSmartReply = fetchSmartReply;
exports.list = list;
exports.nudgeBatchUpdate = nudgeBatchUpdate;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _get = _interopRequireDefault(require("lodash/get"));
var _functools = require("@edison/functools");
var _requests = require("@edison/requests");
var _constants = require("../utils/constants");
var _utils = require("./utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var endpoints = exports.endpoints = {
  list: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/read_thread");
    }
  },
  batchGet: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/message_batch_get");
    }
  },
  fetchSmartReply: {
    method: 'GET',
    url: function url(messageId) {
      return "/".concat(_constants.API_V1, "/smartreply?messageUuid=").concat(messageId);
    }
  },
  feedbackSmartReply: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/smartreply/feedback");
    }
  },
  batchUpdate: {
    method: 'PUT',
    url: function url() {
      return "/".concat(_constants.API_V1, "/message_action");
    }
  },
  batchDelete: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/delete_messages");
    }
  },
  nudgeBatchUpdate: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/nudge/batchmodify");
    }
  },
  fetchOriginal: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/read_message");
    }
  }
};
/**
 * Return a list of mails by specified label and page
 *
 * @param {Auth} auth - User authentication info
 * @param {thread id} threadId - thread id
 * @returns {Promise<MessageListResponse>}
 * @throws {RequestError}
 */
function list(_x, _x2) {
  return _list.apply(this, arguments);
}
function _list() {
  _list = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(threadId, _ref) {
    var auth, optionals, _endpoints$list, method, url, res;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          auth = _ref.auth;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)({
            id: threadId
          }))({});
          _endpoints$list = endpoints.list, method = _endpoints$list.method, url = _endpoints$list.url;
          _context.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          res = _context.sent;
          return _context.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
            result: _objectSpread(_objectSpread({}, res.result), {}, {
              messages: res.result.messages.map(_utils.messageFormatter)
            })
          }));
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _list.apply(this, arguments);
}
/**
 * Update message label by a bunch of message ids
 *
 * @public
 * @param {Auth} auth - User validated authentication
 * @param {string[]} messageIds - Message IDs to update
 * @param {string[]} addLabel - Labels to apply
 * @param {string[]} delLabel - Labels to remove
 * @returns {Promise<APIResponse<any>>}
 */
function batchUpdate(_x3, _x4) {
  return _batchUpdate.apply(this, arguments);
}
function _batchUpdate() {
  _batchUpdate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref2, _ref3) {
    var messageIds, addLabel, delLabel, auth, optionals, _endpoints$batchUpdat, method, url, res;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          messageIds = _ref2.messageIds, addLabel = _ref2.addLabel, delLabel = _ref2.delLabel;
          auth = _ref3.auth;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
            messageIds: messageIds,
            addLabel: addLabel,
            delLabel: delLabel
          }))(_utils.defaultOptionals);
          _endpoints$batchUpdat = endpoints.batchUpdate, method = _endpoints$batchUpdat.method, url = _endpoints$batchUpdat.url;
          _context2.next = 6;
          return (0, _requests.request)(url(), method, optionals);
        case 6:
          res = _context2.sent;
          return _context2.abrupt("return", res);
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _batchUpdate.apply(this, arguments);
}
/**
 * Batch delete message by id
 *
 * @public
 * @param {Auth} auth - User validated authentication
 * @param {string[]} messageIds - Message IDs to delete
 * @returns {Promise<APIResponse<any>>}
 */
function batchDelete(_x5, _x6) {
  return _batchDelete.apply(this, arguments);
}
function _batchDelete() {
  _batchDelete = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(_ref4, _ref5) {
    var messageIds, auth, optionals, _endpoints$batchDelet, method, url, res;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          messageIds = _ref4.messageIds;
          auth = _ref5.auth;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
            messageIds: messageIds
          }))(_utils.defaultOptionals);
          _endpoints$batchDelet = endpoints.batchDelete, method = _endpoints$batchDelet.method, url = _endpoints$batchDelet.url;
          _context3.next = 6;
          return (0, _requests.request)(url(), method, optionals);
        case 6:
          res = _context3.sent;
          return _context3.abrupt("return", res);
        case 8:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _batchDelete.apply(this, arguments);
}
/**
 * Get smartreply of the message with message uuid
 *
 * @param {Auth} auth - User authentication info
 * @param {string} messageuuid - message uiid
 * @returns {Promise<GetSmartReplyResponse>}
 * @throws {RequestError}
 */
function fetchSmartReply(_x7, _x8) {
  return _fetchSmartReply.apply(this, arguments);
}
function _fetchSmartReply() {
  _fetchSmartReply = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(messageId, _ref6) {
    var auth, optionals, _endpoints$fetchSmart, method, url, res;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          auth = _ref6.auth;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals);
          _endpoints$fetchSmart = endpoints.fetchSmartReply, method = _endpoints$fetchSmart.method, url = _endpoints$fetchSmart.url;
          _context4.next = 5;
          return (0, _requests.request)(url(messageId), method, optionals);
        case 5:
          res = _context4.sent;
          return _context4.abrupt("return", res);
        case 7:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _fetchSmartReply.apply(this, arguments);
}
/**
 * Post smartreply feedback for the message with message uuid
 *
 * @param {Auth} auth - User authentication info
 * @param {string} messageuuid - message uiid
 * @param {FeedbackType} feedbackType - feedback type
 * @returns {Promise<FeedbackSmartReplyResponse>}
 * @throws {RequestError}
 */
function feedbackSmartReply(_x9, _x10, _x11) {
  return _feedbackSmartReply.apply(this, arguments);
}
function _feedbackSmartReply() {
  _feedbackSmartReply = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(messageId, feedbackType, _ref7) {
    var auth, optionals, _endpoints$feedbackSm, method, url, res;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          auth = _ref7.auth;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
            messageUuid: messageId,
            feedbackType: feedbackType
          }))(_utils.defaultOptionals);
          _endpoints$feedbackSm = endpoints.feedbackSmartReply, method = _endpoints$feedbackSm.method, url = _endpoints$feedbackSm.url;
          _context5.next = 5;
          return (0, _requests.request)(url(messageId), method, optionals);
        case 5:
          res = _context5.sent;
          return _context5.abrupt("return", res);
        case 7:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _feedbackSmartReply.apply(this, arguments);
}
/**
 * Batch get message by messageIds
 *
 * @param {Auth} auth - User authentication info
 * @param {Array<string>} messageIds - message ids
 * @returns {Promise<BatchGetResponse>}
 * @throws {RequestError}
 */
function batchGet(_x12, _x13) {
  return _batchGet.apply(this, arguments);
}
function _batchGet() {
  _batchGet = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(messageIds, _ref8) {
    var auth, optionals, _endpoints$batchGet, method, url, res, messages;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          auth = _ref8.auth;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
            messageIds: messageIds
          }))(_utils.defaultOptionals);
          _endpoints$batchGet = endpoints.batchGet, method = _endpoints$batchGet.method, url = _endpoints$batchGet.url;
          _context6.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          res = _context6.sent;
          messages = (0, _get["default"])(res, 'result.messages', []) || [];
          return _context6.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
            result: _objectSpread(_objectSpread({}, res.result), {}, {
              messages: messages.map(_utils.messageFormatter)
            })
          }));
        case 8:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _batchGet.apply(this, arguments);
}
/**
 * Batch update status for nudges
 *
 * @public
 * @param {Auth} auth - User validated authentication
 * @param {string[]} messageIds - Message IDs to update
 * @returns {Promise<APIResponse<void>>}
 */
function nudgeBatchUpdate(_x14, _x15) {
  return _nudgeBatchUpdate.apply(this, arguments);
}
/**
 * Fetch original message
 *
 * @public
 * @param {string} messageId - Message IDx
 * @param {Auth} auth - User validated authentication
 * @returns {Promise<APIResponse<void>>}
 */
function _nudgeBatchUpdate() {
  _nudgeBatchUpdate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(_ref9, _ref10) {
    var messageIds, status, auth, optionals, _endpoints$nudgeBatch, method, url, res;
    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          messageIds = _ref9.messageIds, status = _ref9.status;
          auth = _ref10.auth;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
            ids: messageIds,
            status: status
          }))(_utils.defaultOptionals);
          _endpoints$nudgeBatch = endpoints.nudgeBatchUpdate, method = _endpoints$nudgeBatch.method, url = _endpoints$nudgeBatch.url;
          _context7.next = 6;
          return (0, _requests.request)(url(), method, optionals);
        case 6:
          res = _context7.sent;
          return _context7.abrupt("return", res);
        case 8:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _nudgeBatchUpdate.apply(this, arguments);
}
function fetchOriginal(_x16, _x17) {
  return _fetchOriginal.apply(this, arguments);
}
function _fetchOriginal() {
  _fetchOriginal = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(messageId, _ref11) {
    var auth, optionals, _endpoints$fetchOrigi, method, url, res;
    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          auth = _ref11.auth;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)({
            id: messageId,
            format: 'raw',
            tp: 'raw'
          }))(_utils.defaultOptionals);
          _endpoints$fetchOrigi = endpoints.fetchOriginal, method = _endpoints$fetchOrigi.method, url = _endpoints$fetchOrigi.url;
          _context8.next = 5;
          return fetch("".concat(url(), "?id=").concat(messageId, "&format=raw&tp=raw"), _objectSpread(_objectSpread({}, optionals), {}, {
            method: method
          }));
        case 5:
          res = _context8.sent;
          if (res.ok) {
            _context8.next = 8;
            break;
          }
          throw new _requests.RequestError(res.statusText, res.status, res.status);
        case 8:
          return _context8.abrupt("return", res.text());
        case 9:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _fetchOriginal.apply(this, arguments);
}
//# sourceMappingURL=messages.js.map